import React, { useState, useEffect, useMemo } from "react";
import { VStack, Box, StackDivider } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { useApolloClient } from "@apollo/client";

import Item from "./Item";
import EmptyBox from "components/EmptyBox";
import {
  AthleteBirthdayDocument,
  AthleteBirthdayCrossYearDocument,
} from "lib/api/sdk";
import AdminCard from "components/AdminCard";
import { useDashboardContext } from "src/contexts/DashboardContext";

const RenderData = () => {
  const { startDate, endDate } = useDashboardContext();
  const apolloClient = useApolloClient();
  const t = useTranslations("pages.homePage.birthdays");

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);

  const [startMonthDay, endMonthDay] = useMemo(() => {
    return [
      (startDate.getMonth() + 1) * 100 + startDate.getDate(),
      (endDate.getMonth() + 1) * 100 + endDate.getDate(),
    ];
  }, [startDate, endDate]);

  // Determine which query to use based on date range
  const queryDocument = useMemo(() => (startMonthDay > endMonthDay ? AthleteBirthdayCrossYearDocument : AthleteBirthdayDocument), [startMonthDay, endMonthDay]);

  // Execute query when queryDocument changes
  useEffect(() => {
    if (!queryDocument) return;

    setLoading(true);
    apolloClient
      .query({
        query: queryDocument,
        variables: {
          _month_day_gte: startMonthDay,
          _month_day_lte: endMonthDay,
        },
      })
      .then(result => {
        setData(result.data.athletes || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [queryDocument, startMonthDay, endMonthDay, apolloClient]);

  if (loading)
    return (
      <VStack spacing={4} w="full" divider={<StackDivider />}>
        {[0, 1, 2].map(i => (
          <Item key={i} isLoading />
        ))}
      </VStack>
    );

  if (data && data.length)
    return (
      <VStack spacing={4} w="full" divider={<StackDivider />}>
        {data.map((athlete: any) => (
          <Item key={athlete.id} isLoading={loading} athlete={athlete} />
        ))}
      </VStack>
    );

  return (
    <Box w="full">
      <VStack spacing={4} w="full">
        <EmptyBox message={t("noBirthdays")} />
      </VStack>
    </Box>
  );
};

const BirthdaysCard = () => {
  const t = useTranslations("pages.homePage.birthdays");
  return (
    <AdminCard title={t("birthdays")} h="full">
      <RenderData />
    </AdminCard>
  );
};

export default BirthdaysCard;
